export const DEPARTMENT_POSITION_STATUS_VALUES = ["draft", "active", "retired", "inactive"];

export const convertDepartmentPositionFiltersToApi = (chips = []) =>
  (chips || [])
    .map((chip) => String(chip?.key || chip?.value || chip?.label || "").toLowerCase())
    .filter((value) => DEPARTMENT_POSITION_STATUS_VALUES.includes(value));

export const resolveDepartmentPositionArchivedFilter = (chips = []) => {
  const keys = new Set(
    (chips || []).map((chip) => String(chip?.key || chip?.value || chip?.label || ""))
  );
  if (keys.has("Show") || keys.has("show_archived")) {
    return true;
  }
  if (keys.has("Do not Show") || keys.has("no_archived")) {
    return false;
  }
  return false;
};
